import i18n from '../../../../i18n';
import { RecommendationLevel } from '../../../../types/Recommendations';

// This function splits long words with 'insurance' into 2 words to fix weird line breaks
export const manipulateLabel = (text: string): string => {
  const words = text.split(' ');
  const fixedWords = words.map((word) => {
    if (word.length > 22) {
      return word.replace(
        i18n.t('Insurance').toLowerCase(),
        ' ' + i18n.t('Insurance').toLowerCase(),
      );
    }
    return word;
  });
  return fixedWords.join(' ').toString();
};

export const isAdvised = (level: RecommendationLevel): boolean =>
  level !== 'NOT';
